import React from 'react'
import RenderShareTemplates from './RenderShareTemplates'
import ShareSelectedTheme from './ShareSelectedTheme'
import { ThemeConfiguration } from './ThemeConfiguration'

export default function ShareToSocialMedia() {
	const shareMediaThemeConfig = ThemeConfiguration
	const callParentFunction = (item) => {
		console.log(item, 'here is the item in share to social media')
		// here set the selected theme as passed from the child
		// setSelectedTheme(item)
	}
	return (
		<>
			<RenderShareTemplates
				shareMediaThemeConfig={shareMediaThemeConfig}
				callParentFunction={callParentFunction}
			/>
			<ShareSelectedTheme />
		</>
	)
}
